<template>
  <div class="list_wrapper">
    <div class="list">
      <div class="lsit_l">
        <div class="emain_circle">
          <span class="icon-email"></span>
        </div>
      </div>
      <div class="lsit_r">
          <div class="list_time">
            昨天 12:45:06
          </div>
          <div class="cont_wrapper">
            <p>券王全新升级！体验就能得券币！快来呀！
            </p>
            <router-link to="/userCenter" class="see_details">查看详情</router-link>
            <img src="../../../images/triangle_right.png" class="triangle_right" />
          </div>
      </div>
    </div>
  </div>
</template>
<script type = "text/ecamscript-6">
/* eslint-disable */
  export default {
    name:"systemNotify",
  }
</script>
<style lang="stylus">
  .list_wrapper
    padding:0 40px
    .list
      margin-top:25px
      display:flex
      .lsit_l
        flex:0 0 85px
        padding-top:60px
        .emain_circle
          width:64px
          height:64px
          background:#ff6e25
          border-radius:32px
          font-size:32px
          line-height:56px
          text-align:center
          color:#fff
          font-weight:bold
          padding-top:8px
          box-sizing:border-box
      .lsit_r
        flex:1
        position:relative
        .list_time
          text-align:center
          font-size:24px
          color:#808080
        .cont_wrapper
          margin-top:15px
          background:#fff
          padding:25px 35px
          box-sizing:border-bx
          border:1px solid #e6e6e6
          /*px*/
          border-radius:20px
          position:relative
          .triangle_right
            width:13px
            height:14px
            position:absolute
            left:-13px
            top:20px

</style>



// WEBPACK FOOTER //
// src/components/userCenter/news/systemNotify.vue